export const EvaluationSkillFramework = {
    path: '/evaluation_skill_frameworks',
    name: 'evaluation_skill_frameworks',
    component: () => import('@/views/Evaluation/Skill/Framework/EvaluationSkillFrameworkPage.vue'),
    children: [
        {
            path: '/evaluation_skill_frameworks/add',
            name: 'evaluation_skill_frameworks.add',
            component: () => import('@/views/Evaluation/Skill/Framework/Form/EvaluationSkillFrameworkForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/evaluation_skill_frameworks/edit/:id',
            name: 'evaluation_skill_frameworks.edit',
            component: () => import('@/views/Evaluation/Skill/Framework/Form/EvaluationSkillFrameworkForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/evaluation_skill_frameworks/delete/:id',
            name: 'evaluation_skill_frameworks.delete',
            component: () => import('@/views/Evaluation/Skill/Framework/Form/EvaluationSkillFrameworkForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/evaluation_skill_frameworks/view/:id',
            name: 'evaluation_skill_frameworks.view',
            component: () => import('@/views/Evaluation/Skill/Framework/Form/EvaluationSkillFrameworkForm.vue'),
            props: {viewAction: true}
        },
    ]
}